import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cardMakeAdd, cardMakeLogs, cardMakeUpdate, getCardMakeCustomerList, getCardMakeOrderList, getCardMakeSupplierList, getUpdateInfoNew } from '@/views/salesCardManagement/api';
import uploadFile from '@/components/upload/uploadFile.vue';
import AddMaterialDialog from './AddMaterialDialog.vue';
import PrintingUploadDialog from '@/views/salesCardManagement/printingUploadDialog';
import applyForm from '@/views/cardSystem/saleToos/projectDelivery/applyForm.vue';
export default {
  name: 'CreatePrintingRecord',
  components: {
    uploadFile: uploadFile,
    AddMaterialDialog: AddMaterialDialog,
    PrintingUploadDialog: PrintingUploadDialog,
    applyForm: applyForm
  },
  props: {
    drawerParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // 其他物料（个性化印刷-添加物料）弹框显隐（弹框本身抽成 AddMaterialDialog 子组件）
      addMaterialDialog: {
        visible: false
      },
      // 传给 AddMaterialDialog 的参数（{ print_type, batch }）
      addMaterialParams: {},
      // 物料明细 - 当前正在上传设计稿的物料 id（emitGetMaterial 时回写 design_img 用）
      currentUploadingMaterialId: '',
      id: '',
      project_id: '',
      // 工单进入时的项目 id
      item_id: '',
      //工单进入时的项目 id
      batch: '',
      // 制卡管理进入时的批次号
      linkUrl: {
        config: '/cardmake/image/upload/config',
        extensions: '/cardmake/image/upload/file-allow-extensions'
      },
      supplierList: [],
      submitLoading: false,
      logList: [],
      // 日志
      pages: {},
      logForm: {
        page: 1
      },
      make_card_id: '',
      // 制卡id
      // ===== 新版：页面上方信息聚合（直接用后端返回的字段名，方便调试）=====
      customer_info: {},
      // 客户信息
      project_delivery_info: {},
      // 设计工单
      card_make_info: {},
      // 制卡信息（无数据时为 null）
      // 物料明细数组（二维，外层每个物料含 branch_office_data 子数组）
      material_arr: [],
      // 印刷信息
      printInfo: {
        print_type: '1',
        // 印刷类型
        supplier_id: '',
        // 供应商
        is_urgent: '0',
        // 是否加急 1:是 0:否
        customer_id: '',
        // 关联客户
        sale_user_id: '',
        // 销售负责人
        branch_office_select: [] // 分公司/仓库下拉（物料明细分配用）
      },
      // 费用信息（material_money 按物料类型循环；其他为单一费用字段）
      fee_info: {
        material_money: [],
        print_money: '',
        express_fee: '',
        total_money: '',
        company_money: '',
        person_money: '',
        coupon_cost: '',
        real_supplier_money: ''
      },
      // 状态&备注（直连后端 state_info）
      state_info: {},
      // 关联信息（直连后端 order_info，规则字段同步）
      // 费用信息表单校验规则
      feeRules: {
        price: [{
          required: true,
          trigger: 'change',
          message: '请输入印刷单价'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          trigger: 'change',
          message: '单价仅支持2位小数'
        }],
        number: [{
          required: true,
          trigger: 'change',
          message: '请输入数量'
        }, {
          pattern: /^\d+$/,
          trigger: 'change',
          message: '数量仅支持数字'
        }],
        print_money: [{
          required: true,
          trigger: 'change',
          message: '请输入印刷费用'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          trigger: 'change',
          message: '费用仅支持2位小数'
        }],
        money: [{
          required: true,
          trigger: 'change',
          message: '请输入金额'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          trigger: 'change',
          message: '费用仅支持2位小数'
        }]
      },
      // 展开行控制，接口数据返回后默认展开全部物料行
      expandedRowKeys: [],
      topFormLoading: false,
      from: 'printing',
      is_card_disabled: false,
      // 制卡管理过来的，分公司和制卡数量不让改
      print_type_disabled: false,
      // 印刷类型 制卡 工单过来不让修改
      applyFormVisible: false,
      applyFormType: 'view',
      selectedId: null,
      selectedProjectType: null,
      selectedProjectStatus: null,
      drawerTitle: '装修&项目交付申请',
      normalizedFromTab: '2',
      material_apply__disabled: false,
      CustomerList: [],
      sale_userList: []
    };
  },
  computed: {
    // 已选物料的 material_id 列表，传给 AddMaterialDialog 用于去重
    existingMaterialIds: function existingMaterialIds() {
      return (this.material_arr || []).map(function (item) {
        return item.material_id;
      }).filter(function (id) {
        return id !== undefined && id !== null && id !== '';
      });
    },
    // 物料明细表单 model（供 el-form 校验用，prop 路径形如 material_arr.0.craft_type）
    materialFormData: function materialFormData() {
      return {
        material_arr: this.material_arr || []
      };
    },
    // 判断是否存在 from_summary = 1 的分公司数据
    hasFromSummary: function hasFromSummary() {
      if (!this.material_arr || this.material_arr.length === 0) return false;
      return this.material_arr.some(function (material) {
        var branchList = material.branch_office_data || [];
        return branchList.some(function (branch) {
          return String(branch.from_summary) === '1';
        });
      });
    },
    sellUserList: function sellUserList() {
      return this.$store.state.user.sellUsersList;
    }
  },
  created: function created() {
    this.$store.dispatch('app/linkUrl', this.linkUrl);
    if (this.drawerParams) {
      this.id = this.drawerParams.id || ''; // 销售运营 用这个请求
      this.project_id = this.drawerParams.project_id || ''; // 工单用这个
      this.item_id = this.drawerParams.item_id || '';
      this.batch = this.drawerParams.batch || ''; // 制卡管理用这个请求
      this.from = this.drawerParams.from || ''; //  details 不显示保存按钮
      this.material_apply_summary_id = this.drawerParams.material_apply_summary_id || '';
      if (this.material_apply_summary_id) {
        this.material_apply__disabled = true; // 禁用 印刷类型 物料明细的操作移除
      }
    }
    if (this.drawerParams && this.drawerParams.type == 'edit') {
      this.getLog();
    }
    if (this.drawerParams.is_getApi === '1') {
      this.getUpdateInfoNewData();
    } else {
      this.getCustomerList('');
    }
    // 制卡管理过来的，分公司和制卡数量不让改
    if (this.drawerParams.is_make_card === '1') {
      this.is_card_disabled = true;
    }
    if (this.drawerParams.is_make_card === '1' || this.drawerParams.from === 'project') {
      this.print_type_disabled = true;
    }
    this.getSupplier();
  },
  methods: {
    // ===== 新版：页面上方信息聚合 =====
    getUpdateInfoNewData: function getUpdateInfoNewData() {
      var _this = this;
      this.topFormLoading = true;
      var params = {
        id: this.id,
        project_id: this.project_id,
        batch: this.batch,
        material_apply_summary_id: this.material_apply_summary_id
      };
      getUpdateInfoNew(params).then(function (res) {
        var data = res && res.data || {};
        _this.drawerParams.id = data.id || '';
        _this.drawerParams.batch = data.batch;
        _this.customer_info = data.customer_info || {};
        _this.project_delivery_info = data.project_delivery_info || {};
        _this.card_make_info = data.card_make_info || {};
        _this.material_arr = data.material_arr || [];
        _this.expandedRowKeys = _toConsumableArray(_this.existingMaterialIds);
        // 兜底补齐费用字段结构，避免后端缺字段时模板/计算报错
        _this.fee_info = _objectSpread({
          material_money: [],
          print_money: '',
          express_fee: '',
          total_money: '',
          company_money: '',
          person_money: '',
          coupon_cost: '',
          real_supplier_money: ''
        }, data.fee_info || {});
        _this.printInfo = _objectSpread({
          customer_id: '',
          sale_user_id: ''
        }, data.print_info || {});
        if (_this.printInfo.customer_id && _this.printInfo.customer_name) {
          _this.getCustomerList(_this.printInfo.customer_name);
        }
        _this.state_info = data.state_info || {};
      }).catch(function (err) {
        console.error('获取 update-info-new 失败：', err);
      }).finally(function () {
        _this.topFormLoading = false;
      });
    },
    // 费用信息计算：印刷费用合计 = 各类型印刷费用合计；含运费 = 印刷费用合计 + 快递运费
    computeFeeInfo: function computeFeeInfo() {
      var list = this.fee_info.material_money || [];
      var total = 0;
      list.forEach(function (item) {
        var money = parseFloat(item.print_money);
        if (!isNaN(money)) {
          total += money;
        }
      });
      // 印刷费用合计
      this.fee_info.print_money = total.toFixed(2);
      // 含运费 = 印刷费用合计 + 快递运费
      var express = parseFloat(this.fee_info.express_fee) || 0;
      this.fee_info.total_money = (total + express).toFixed(2);
      // 销售承担费用 = 总费用 - 公司承担费用
      var totalMoney = total + express; // 总费用 = 印刷费用合计 + 快递运费
      var companyMoney = parseFloat(this.fee_info.company_money) || 0;
      if (totalMoney && companyMoney) {
        if (companyMoney > totalMoney) {
          this.$message.error('公司承担费用不得大于总费用');
        } else {
          this.fee_info.person_money = (totalMoney - companyMoney).toFixed(2);
        }
      } else {
        this.fee_info.person_money = '';
      }
      // 应付供应商金额 = 总费用 - 优惠金额（优惠金额为 0 或空时按 0 参与计算）
      var couponCost = parseFloat(this.fee_info.coupon_cost) || 0;
      if (totalMoney) {
        this.fee_info.real_supplier_money = (totalMoney - couponCost).toFixed(2);
      } else {
        this.fee_info.real_supplier_money = '';
      }
    },
    // 印刷单价输入：只保留数字和小数点，最多2位小数，然后按 单价×数量 计算印刷费用
    onFeePriceInput: function onFeePriceInput(item) {
      item.price = String(item.price || '').replace(/[^\d.]/g, '').replace(/\.(?=.*\.)/g, '').replace(/^(\d*\.\d{0,2}).*$/, '$1');
      var p = parseFloat(item.price);
      var n = parseFloat(item.number);
      if (!isNaN(p) && !isNaN(n)) {
        item.print_money = (p * n).toFixed(2);
      }
      this.computeFeeInfo();
    },
    // 数量输入：只保留整数，然后按 单价×数量 计算印刷费用
    onFeeNumberInput: function onFeeNumberInput(item) {
      item.number = String(item.number || '').replace(/[^\d]/g, '');
      var p = parseFloat(item.price);
      var n = parseFloat(item.number);
      if (!isNaN(p) && !isNaN(n)) {
        item.print_money = (p * n).toFixed(2);
      }
      this.computeFeeInfo();
    },
    // 印刷费用输入：只保留数字和小数点（最多2位），反推印刷单价 = 印刷费用 ÷ 数量
    onFeePrintMoneyInput: function onFeePrintMoneyInput(item) {
      item.print_money = String(item.print_money || '').replace(/[^\d.]/g, '').replace(/\.(?=.*\.)/g, '').replace(/^(\d*\.\d{0,2}).*$/, '$1');
      var money = parseFloat(item.print_money);
      var n = parseFloat(item.number);
      if (!isNaN(money) && !isNaN(n) && n > 0) {
        item.price = (money / n).toFixed(2);
      }
      this.computeFeeInfo();
    },
    // 快递运费/公司承担费用/优惠金额输入：只保留数字和小数点（最多2位），然后重算合计项
    onFeeMoneyInput: function onFeeMoneyInput(field) {
      this.fee_info[field] = String(this.fee_info[field] || '').replace(/[^\d.]/g, '').replace(/\.(?=.*\.)/g, '').replace(/^(\d*\.\d{0,2}).*$/, '$1');
      this.computeFeeInfo();
    },
    // 物料明细 展开/折叠 切换
    handleExpandChange: function handleExpandChange(row, expandedRows) {
      this.expandedRowKeys = expandedRows.map(function (item) {
        return item.material_id;
      });
    },
    // 获取供应商
    getSupplier: function getSupplier() {
      var _this2 = this;
      getCardMakeSupplierList().then(function (res) {
        _this2.supplierList = res.data || [];
      });
    },
    // 物料明细 - 给指定物料新增一条仓库分配行（标准版）
    addMaterialBranch: function addMaterialBranch(materialIndex) {
      if (!this.material_arr[materialIndex]) return;
      if (!this.material_arr[materialIndex].branch_office_data) {
        this.$set(this.material_arr[materialIndex], 'branch_office_data', []);
      }
      this.material_arr[materialIndex].branch_office_data.push({
        branch_office_id: '',
        branch_office_name: '',
        begin_code: '',
        end_code: '',
        make_count: '',
        address: '',
        from_summary: ''
      });
    },
    // 物料明细 - 删除指定物料的某条仓库分配行（标准版）
    delMaterialBranch: function delMaterialBranch(materialIndex, branchIndex) {
      var list = this.material_arr[materialIndex] && this.material_arr[materialIndex].branch_office_data;
      if (!list || !list.length) return;
      // 最后一条不允许删除
      if (list.length <= 1) {
        this.$message.warning('至少保留一条仓库分配数据');
        return;
      }
      list.splice(branchIndex, 1);
    },
    // 物料明细 - 选分公司后带回名称、地址和默认印刷数量
    changeMaterialBranch: function changeMaterialBranch(materialIndex, row) {
      if (!row || !row.branch_office_id) {
        row.address = '';
        row.branch_office_name = '';
        row.make_count = '';
        return;
      }
      // 使用当前物料自身的 branch_office_select
      var material = this.material_arr[materialIndex];
      var list = material && material.branch_office_select;
      var target = (list || []).find(function (item) {
        return String(item.id) === String(row.branch_office_id);
      });
      if (target) {
        row.address = target.address || '';
        row.branch_office_name = target.name || '';
        // 切换分公司时重新从数据中获取印刷数量
        row.make_count = target.make_count ? String(target.make_count) : 0;
      }
      this.updateFeeNumber(materialIndex);
    },
    // 同步费用明细：基于当前 material_arr 重新聚合 material_money
    // - 同 material_type_des 的物料只保留一条费用记录
    // - 已删除物料类型对应的费用记录移除
    // - 已填写的 price / print_money 保留
    syncFeeMaterialMoney: function syncFeeMaterialMoney() {
      var _this3 = this;
      if (!this.fee_info) this.fee_info = {
        material_money: []
      };
      if (!Array.isArray(this.fee_info.material_money)) this.fee_info.material_money = [];
      var oldList = this.fee_info.material_money;
      var result = [];
      var seen = new Set();
      (this.material_arr || []).forEach(function (m) {
        var des = m.material_type_des;
        if (!des || seen.has(des)) return;
        seen.add(des);
        var old = oldList.find(function (o) {
          return o.material_type_des === des;
        });
        var totalCount = (_this3.material_arr || []).filter(function (item) {
          return item.material_type_des === des;
        }).reduce(function (s, item) {
          var sub = (item.branch_office_data || []).reduce(function (subS, b2) {
            return subS + (parseInt(b2.make_count) || 0);
          }, 0);
          return s + sub;
        }, 0);
        result.push({
          material_id: m.material_id,
          material_type: m.material_type,
          material_type_des: des,
          price: old ? old.price : '',
          number: String(totalCount || 0),
          print_money: old ? old.print_money : '0.00'
        });
      });
      this.fee_info.material_money = result;
    },
    // 同步物料明细印刷数量到费用信息，并按 单价×数量 重算印刷费用与合计
    updateFeeNumber: function updateFeeNumber(idx) {
      var m = this.material_arr[idx];
      if (!m) return;
      var cnt = (m.branch_office_data || []).reduce(function (s, b) {
        return s + (parseInt(b.make_count) || 0);
      }, 0);
      var fee = (this.fee_info.material_money || []).find(function (f) {
        return f.material_type_des === m.material_type_des;
      });
      if (fee) {
        fee.number = String(cnt);
        // 数量变化后同步重算：印刷费用 = 单价 × 数量
        var p = parseFloat(fee.price);
        if (!isNaN(p) && cnt > 0) {
          fee.print_money = (p * cnt).toFixed(2);
        } else {
          fee.print_money = '';
        }
      }
      this.computeFeeInfo();
    },
    // 判断某个分公司是否已被同物料的其他行选中（用于禁用重复选择）
    isBranchOfficeSelected: function isBranchOfficeSelected(materialIndex, currentIndex, branchOfficeId) {
      var list = this.material_arr[materialIndex] && this.material_arr[materialIndex].branch_office_data || [];
      return list.some(function (item, idx) {
        return idx !== currentIndex && String(item.branch_office_id) === String(branchOfficeId);
      });
    },
    // 物料明细 - 合计印刷数量（标准版）
    getMaterialBranchTotal: function getMaterialBranchTotal(materialIndex) {
      var list = this.material_arr[materialIndex] && this.material_arr[materialIndex].branch_office_data || [];
      return list.reduce(function (sum, item) {
        var n = Number(item.make_count);
        return sum + (isNaN(n) ? 0 : n);
      }, 0);
    },
    // 物料明细 - 合计申请制作数量（from_summary = 1 时显示）
    getApplyQuantityTotal: function getApplyQuantityTotal(materialIndex) {
      var list = this.material_arr[materialIndex] && this.material_arr[materialIndex].branch_office_data || [];
      return list.reduce(function (sum, item) {
        var n = Number(item.apply_quantity);
        return sum + (isNaN(n) ? 0 : n);
      }, 0);
    },
    // 物料明细 - 合计拟印刷数量（from_summary = 1 时显示）
    getPlannedPrintQuantityTotal: function getPlannedPrintQuantityTotal(materialIndex) {
      var list = this.material_arr[materialIndex] && this.material_arr[materialIndex].branch_office_data || [];
      return list.reduce(function (sum, item) {
        var n = Number(item.planned_print_quantity);
        return sum + (isNaN(n) ? 0 : n);
      }, 0);
    },
    // 分公司子表合计行方法（参考 materialApplyConfirmDrawer.vue）
    getBranchOfficeSummary: function getBranchOfficeSummary(_ref) {
      var columns = _ref.columns,
        data = _ref.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          // 序号列
          sums[index] = '';
        } else if (column.label === '申请制作数量') {
          var total = data.reduce(function (sum, item) {
            return sum + (Number(item.apply_quantity) || 0);
          }, 0);
          sums[index] = '合计：' + total;
        } else if (column.label === '拟印刷数量') {
          var _total = data.reduce(function (sum, item) {
            return sum + (Number(item.planned_print_quantity) || 0);
          }, 0);
          sums[index] = '合计：' + _total;
        } else if (column.label === '印刷数量') {
          var _total2 = data.reduce(function (sum, item) {
            return sum + (Number(item.make_count) || 0);
          }, 0);
          sums[index] = '合计印刷数量：' + _total2;
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 物料明细 - 移除物料行（二次确认：先 $confirm 弹框，确定后再删除）
    confirmRemoveRow: function confirmRemoveRow(index) {
      var _this4 = this;
      if (!this.material_arr || !this.material_arr[index]) return;
      var row = this.material_arr[index];
      this.$confirm("\u786E\u5B9A\u8981\u79FB\u9664\u7269\u6599\u3010".concat(row.name || row.material_id, "\u3011\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var removed = _this4.material_arr[index];
        _this4.material_arr.splice(index, 1);
        // 同步费用明细：按 material_type_des 重新聚合
        _this4.syncFeeMaterialMoney();
        _this4.$message.success('移除成功');
      }).catch(function () {});
    },
    // 切换印刷类型：清空物料明细 + 费用信息（恢复初始状态）
    // 不动印刷信息自身（类型已由用户切换），不动 design_img
    onPrintTypeChange: function onPrintTypeChange() {
      var _this5 = this;
      // 物料明细清空
      this.material_arr = [];
      this.expandedRowKeys = [];
      // 费用信息清空（恢复成只含空 material_money 的初始对象，保持完整字段结构）
      this.fee_info = {
        material_money: [],
        print_money: '',
        express_fee: '',
        total_money: '',
        company_money: '',
        person_money: '',
        coupon_cost: '',
        real_supplier_money: ''
      };
      // 清掉费用信息表单的校验态（避免红字残留）
      this.$nextTick(function () {
        if (_this5.$refs.feeForm) {
          _this5.$refs.feeForm.clearValidate();
        }
      });
    },
    // 打开【添加物料】弹框（弹框本身在 AddMaterialDialog 子组件中）
    openAddMaterialDialog: function openAddMaterialDialog() {
      var event = this.$refs.AddMaterialDialog;
      event.form.type = this.drawerParams.batch ? '0' : '2';
      event.form.batch = this.drawerParams.batch;
      event.form.print_type = this.printInfo.print_type;
      event.is_make_card = this.is_card_disabled; // is_card_disabled true 代表是从制卡管理过来的
      // 传递已添加的 PVC卡/券 类型，用于二次校验防止重复添加
      if (this.is_card_disabled) {
        event.existingCardCouponTypes = (Array.isArray(this.material_arr) ? this.material_arr : []).filter(function (item) {
          return String(item.material_type) === '1' || String(item.material_type) === '2';
        }).map(function (item) {
          return String(item.material_type);
        });
      } else {
        event.existingCardCouponTypes = [];
      }
      event.visibleAddMaterial = true;
      event.getList();
    },
    // 弹框提交回调（多选）：把新物料 push 到 material_arr，并同步费用信息 material_money
    handleAddMaterialSubmit: function handleAddMaterialSubmit(selection) {
      var _this6 = this;
      var list = Array.isArray(selection) ? selection : [selection];
      if (!list.length) return;
      if (!this.material_arr) this.material_arr = [];
      if (!this.fee_info.material_money) this.fee_info.material_money = [];
      var added = [];
      list.forEach(function (row) {
        // 二次去重：防止用户绕过弹框过滤逻辑
        if (_this6.material_arr.some(function (m) {
          return String(m.material_id) === String(row.material_id);
        })) {
          return;
        }
        var newItem = _objectSpread({}, row);
        _this6.material_arr.push(newItem);
        added.push(newItem);

        // 同步费用信息 material_money（按 material_type_des 去重，不存在则新增）
        var exist = _this6.fee_info.material_money.find(function (m) {
          return m.material_type_des === newItem.material_type_des;
        });
        if (!exist) {
          var totalCount = (newItem.branch_office_data || []).reduce(function (s, b) {
            return s + (parseInt(b.make_count) || 0);
          }, 0);
          _this6.fee_info.material_money.push({
            material_id: newItem.material_id,
            material_type: newItem.material_type,
            material_type_des: newItem.material_type_des,
            price: '',
            number: String(totalCount),
            print_money: '0.00'
          });
        }
      });
      if (!added.length) {
        this.$message.warning('所选物料已存在，未重复添加');
        return;
      }
      // 新添加的物料默认展开分公司/仓库子表
      if (!this.expandedRowKeys) this.expandedRowKeys = [];
      added.forEach(function (item) {
        if (!_this6.expandedRowKeys.some(function (k) {
          return String(k) === String(item.material_id);
        })) {
          _this6.expandedRowKeys.push(item.material_id);
        }
      });
      // 重新计算费用
      this.computeFeeInfo();
      this.$message.success("\u5DF2\u6DFB\u52A0 ".concat(added.length, " \u4E2A\u7269\u6599"));
    },
    submitForm: function submitForm() {
      var _this7 = this;
      // 1. 物料明细自定义校验
      if (!this.validateMaterialArr()) {
        return;
      }
      // 2. 依次校验 印刷信息 / 费用信息 / 状态&备注
      var validateForm = function validateForm(refName) {
        return new Promise(function (resolve, reject) {
          if (!_this7.$refs[refName]) {
            resolve();
            return;
          }
          _this7.$refs[refName].validate(function (valid) {
            valid ? resolve() : reject(refName);
          });
        });
      };
      Promise.all([validateForm('printForm'), validateForm('materialForm'), validateForm('feeForm'), validateForm('stateForm')]).then(function () {
        _this7.submitLoading = true;
        _this7.drawerParams.type === 'add' ? _this7.createForm() : _this7.updateForm();
      }).catch(function (refName) {
        var map = {
          printForm: '印刷信息',
          materialForm: '物料明细',
          feeForm: '费用信息',
          stateForm: '状态&备注'
        };
        _this7.$message.error("\u8BF7\u5B8C\u5584\u3010".concat(map[refName] || '必填项', "\u3011"));
      });
    },
    // 物料明细自定义校验
    // 至少一条物料；标准版兜底校验展开行字段（展开行未渲染时 form 校验不到）
    // 个性化的工艺材质/规格/设计稿 由 materialForm 校验
    validateMaterialArr: function validateMaterialArr() {
      if (!this.material_arr || this.material_arr.length === 0) {
        this.$message.error('请添加物料明细');
        return false;
      }
      // 个性化：工艺材质/规格/设计稿 由 materialForm 校验，这里直接通过
      // if (String(this.printInfo.print_type) !== '1') {
      // 	return true
      // }
      // 标准版：兜底校验 branch_office_data（展开行未渲染时 form 校验不到）
      for (var i = 0; i < this.material_arr.length; i++) {
        var m = this.material_arr[i];
        var list = m.branch_office_data || [];
        if (list.length === 0) {
          this.$message.error("\u7269\u6599\u3010".concat(m.name || m.material_id, "\u3011\u8BF7\u6DFB\u52A0\u5165\u5E93\u4ED3\u5E93"));
          this.openMaterialRow(m.material_id);
          return false;
        }
        for (var j = 0; j < list.length; j++) {
          var b = list[j];
          if (!b.branch_office_id) {
            this.$message.error("\u7269\u6599\u3010".concat(m.name || m.material_id, "\u3011\u7B2C ").concat(j + 1, " \u884C\u8BF7\u9009\u62E9\u5206\u516C\u53F8/\u4ED3\u5E93"));
            this.openMaterialRow(m.material_id);
            return false;
          }
          if (b.make_count === '' || b.make_count === null || b.make_count === undefined || Number(b.make_count) <= 0) {
            this.$message.error("\u7269\u6599\u3010".concat(m.name || m.material_id, "\u3011\u7B2C ").concat(j + 1, " \u884C\u8BF7\u8F93\u5165\u5370\u5237\u6570\u91CF"));
            this.openMaterialRow(m.material_id);
            return false;
          }
          if (!b.address) {
            this.$message.error("\u7269\u6599\u3010".concat(m.name || m.material_id, "\u3011\u7B2C ").concat(j + 1, " \u884C\u8BF7\u8F93\u5165\u5BC4\u9001\u5730\u5740"));
            this.openMaterialRow(m.material_id);
            return false;
          }
        }
      }
      return true;
    },
    // 设计稿校验（materialForm 中 design_img 的 validator）
    validateDesignImg: function validateDesignImg(rule, value, callback) {
      if (!value || !Array.isArray(value) || value.length === 0) {
        // 设计工单设计稿有值时，此处上传设计稿非必填
        var designDraft = this.project_delivery_info.design_draft;
        if (Array.isArray(designDraft) && designDraft.length > 0) {
          callback();
          return;
        }
        callback(new Error('请上传设计稿'));
      } else {
        callback();
      }
    },
    // 自动展开指定物料行（校验失败时定位用）
    openMaterialRow: function openMaterialRow(materialId) {
      if (!materialId) return;
      if (!this.expandedRowKeys.some(function (k) {
        return String(k) === String(materialId);
      })) {
        this.expandedRowKeys.push(materialId);
      }
    },
    createForm: function createForm() {
      var _this8 = this;
      var params = {
        id: this.id,
        batch: this.batch,
        project_id: this.project_id,
        item_id: this.item_id,
        material_apply_summary_id: this.material_apply_summary_id,
        // 印刷信息
        print_info: _objectSpread({}, this.printInfo),
        // 物料明细
        material_arr: this.material_arr.map(function (item) {
          return _objectSpread({}, item);
        }),
        // 费用信息
        fee_info: _objectSpread({}, this.fee_info),
        // 状态&备注
        state_info: _objectSpread({}, this.state_info)
      };
      cardMakeAdd(params).then(function (res) {
        _this8.$message.success('添加成功');
        _this8.$emit('success');
      }).finally(function () {
        _this8.submitLoading = false;
      });
    },
    updateForm: function updateForm() {
      var _this9 = this;
      var params = {
        id: this.id,
        batch: this.batch,
        project_id: this.project_id,
        item_id: this.item_id,
        material_apply_summary_id: this.material_apply_summary_id,
        // 印刷信息
        print_info: _objectSpread({}, this.printInfo),
        // 物料明细
        material_arr: this.material_arr.map(function (item) {
          return _objectSpread({}, item);
        }),
        // 费用信息
        fee_info: _objectSpread({}, this.fee_info),
        // 状态&备注
        state_info: _objectSpread({}, this.state_info)
      };
      cardMakeUpdate(params).then(function (res) {
        _this9.$message.success('编辑成功');
        _this9.$emit('success');
      }).finally(function () {
        _this9.submitLoading = false;
      });
    },
    getLog: function getLog() {
      var _this0 = this;
      var params = {
        id: this.id
      };
      cardMakeLogs(params).then(function (res) {
        _this0.logList = res.data || [];
        _this0.pages = res.pages;
      });
    },
    jumpCustomerList: function jumpCustomerList(row) {
      window.open("".concat(this.$store.state.user.domainName, "/#/cardSystem/customer/customerManagement?customer_id=").concat(row.customer_id), '_blank');
    },
    cancel: function cancel() {
      this.$emit('close');
    },
    // 上传物料设计稿 - 打开上传弹框（沿用 printingRecordsList 逻辑）
    uploadFile: function uploadFile(row) {
      if (!this.$refs.printingUploadDialog) return;
      var event = this.$refs.printingUploadDialog;
      event.printingUploadDialog = true;
      event.ruleForm.id = row.material_id;
      event.formType = 'printing';
      // 本页面点确定不调接口，直接把文件数据回写到物料行
      event.skipApiSubmit = true;
      // 记录当前操作的物料行，emitGet 后用于回写 design_img
      this.currentUploadingMaterialId = row.material_id;
      if (row.design_img && Array.isArray(row.design_img) && row.design_img.length > 0) {
        event.ruleForm.file = _toConsumableArray(row.design_img);
      }
    },
    // 上传成功后，更新对应物料行的 design_img
    emitGetMaterial: function emitGetMaterial(files) {
      var _this1 = this;
      var event = this.$refs.printingUploadDialog;
      if (!event) return;
      // 本地模式下 files 由子组件传入；兜底从 ruleForm.file 取
      var newFiles = Array.isArray(files) && files.length ? _toConsumableArray(files) : Array.isArray(event.ruleForm.file) ? _toConsumableArray(event.ruleForm.file) : [];
      var idx = this.material_arr.findIndex(function (m) {
        return String(m.material_id) === String(_this1.currentUploadingMaterialId);
      });
      if (idx >= 0) {
        this.$set(this.material_arr[idx], 'design_img', newFiles);
      }
    },
    // 获取第一张优先显示的图片（优先 jpg/jpeg/png）
    getFirstImage: function getFirstImage(designImgList) {
      if (!designImgList || designImgList.length === 0) return null;
      var priorityExtensions = ['jpg', 'jpeg', 'png'];
      var _loop = function _loop() {
          var ext = _priorityExtensions[_i];
          var found = designImgList.find(function (img) {
            var fileExtension = img.split('.').pop().toLowerCase();
            return fileExtension === ext;
          });
          if (found) return {
            v: found
          };
        },
        _ret;
      for (var _i = 0, _priorityExtensions = priorityExtensions; _i < _priorityExtensions.length; _i++) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      var firstImage = designImgList.find(function (img) {
        var fileExtension = img.split('.').pop().toLowerCase();
        return imageExtensions.includes(fileExtension);
      });
      return firstImage || null;
    },
    // 判断是否为PDF
    isPDF: function isPDF(filePath) {
      if (!filePath) return false;
      var fileExtension = filePath.split('.').pop().toLowerCase();
      return fileExtension === 'pdf';
    },
    // 判断是否为AI
    isAI: function isAI(filePath) {
      if (!filePath) return false;
      var fileExtension = filePath.split('.').pop().toLowerCase();
      return fileExtension === 'ai';
    },
    // 获取图片列表（过滤掉非图片格式的文件）
    getImageList: function getImageList(designImgList) {
      if (!designImgList || designImgList.length === 0) return [];
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      return designImgList.filter(function (img) {
        var fileExtension = img.split('.').pop().toLowerCase();
        return imageExtensions.includes(fileExtension);
      });
    },
    isImage: function isImage(filePath) {
      var imageExtensions = ['jpg', 'jpeg', 'png'];
      var fileExtension = String(filePath).split('.').pop().toLowerCase();
      return imageExtensions.includes(fileExtension);
    },
    // 判断 design_draft 元素是否为图片（对象取 file_name，字符串直接判断）
    isDesignImage: function isDesignImage(item) {
      var name = item && item.file_name ? item.file_name : item;
      return this.isImage(name);
    },
    // 获取 design_draft 元素的预览 URL（图片）
    getDesignImgUrl: function getDesignImgUrl(item) {
      return item && item.url ? item.url : item;
    },
    // 获取 design_draft 元素用于下载/打开的 URL
    getDesignFileUrl: function getDesignFileUrl(item) {
      return item && item.url ? item.url : item;
    },
    // 获取 design_draft 元素的文件名
    getDesignFileName: function getDesignFileName(item) {
      if (item && item.file_name) return item.file_name;
      return String(item).split('/').pop();
    },
    // 在新窗口打开文件（用于 PDF 等可直接预览的文件）
    openFile: function openFile(url) {
      window.open(url, '_blank');
    },
    // 下载设计稿（图片/文件通用：a 标签 download）
    downloadDesignFile: function downloadDesignFile(item) {
      var fullUrl = this.getDesignFileUrl(item);
      var rawName = this.getDesignFileName(item);
      var baseName = rawName.split('?')[0].split('/').pop();
      var ext = (fullUrl.split('?')[0].split('.').pop() || '').toLowerCase();
      var finalName = ext && !baseName.toLowerCase().endsWith('.' + ext) ? baseName + '.' + ext : baseName;
      fetch(fullUrl).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var objectUrl = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = objectUrl;
        link.download = finalName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      }).catch(function () {
        // 跨域或失败时降级为新窗口打开
        window.open(fullUrl, '_blank');
      });
    },
    // 获取关联客户列表
    getCustomerList: function getCustomerList(val) {
      var _this10 = this;
      var params = {
        customer_name: val
      };
      getCardMakeCustomerList(params).then(function (res) {
        _this10.CustomerList = res.data;
      });
    },
    clearCustomer: function clearCustomer() {
      this.printInfo.sale_user_id = '';
      this.printInfo.customer_id = '';
      this.getCustomerList('');
    },
    // 修改关联客户
    changeCustomer: function changeCustomer(val) {
      var _this11 = this;
      var _iterator = _createForOfIteratorHelper(this.CustomerList),
        _step;
      try {
        var _loop2 = function _loop2() {
          var item = _step.value;
          if (item.id === val) {
            var sellUser = _this11.sellUserList.find(function (user) {
              return String(user.id) === String(item.user_id);
            });
            _this11.printInfo.sale_user_id = sellUser ? sellUser.id : '';
            return 1; // break
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          if (_loop2()) break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    viewProjectDetail: function viewProjectDetail(row) {
      var info = this.project_delivery_info;
      this.selectedId = info.project_delivery_id;
      this.selectedProjectType = info.project_type;
      this.selectedProjectStatus = info.status;
      this.applyFormType = 'view';
      this.drawerTitle = '装修&项目交付申请（任务ID：' + info.project_delivery_id + '）';
      this.applyFormVisible = true;
    },
    currentChange: function currentChange(val) {
      this.logForm.page = val;
      this.getLog();
    }
  }
};